<template>
  <div class="product">
    <!-- <div class="nav">
      <navbar :current-type="currentType" @itemClick="itemClick" />
    </div> -->
    <div class="list">
      <hight-light text="产品中心" bg-text="Product Center" :is-bg="true" id="title" />
      <div class="column">
        <div class="wrpper" v-if="screenWidth > 768">
          <img src="@/assets/swiperProduct/001.png" />
          <Swiper :imgUrl="urlOne" :isBg="isBg" :setHeight="setHg1" :during="during1">
            <label class="sub">{{ subTitle }}</label>
          </Swiper>
        </div>
        <span v-else>
          <img src="@/assets/phone/board.png" />
        </span>
      </div>
      <div class="column">
        <div class="wrpper" v-if="screenWidth > 768">
          <img src="@/assets/swiperProduct/007.png" />
          <Swiper :imgUrl="urlTwo" :isBg="isBg" :setHeight="setHg2" :during="during2">
            <label class="sub">{{ subTitle }}</label>
          </Swiper>
        </div>
        <span v-else>
          <img src="@/assets/phone/digital.png" />
        </span>
      </div>
      <div class="column">
        <div class="wrpper" v-if="screenWidth > 768">
          <img  style="margin-bottom:50px"  src="@/assets/swiperProduct/014.png" />
          <!-- <Swiper :imgUrl="urlThree" :setHeight="setHg3" :during="during3">
          </Swiper> -->
          <ProductList :projects="currentList" img-height="260px"></ProductList>
        </div>
        <span v-else>
          <img  style="margin-bottom:50px"  src="@/assets/phone/001.png" />
          <ProductList :projects="currentList" img-height="260px"></ProductList>
        </span>
      </div>
      <div class="column">
        <div class="wrpper" v-if="screenWidth > 768">
          <img  style="margin-bottom:50px"  src="@/assets/swiperProduct/017-1.png" />
          <!-- <Swiper :imgUrl="urlFour" :setHeight="setHg3" :during="during4">
          </Swiper> -->
          <ProductList :projects="deviceList" img-height="260px"></ProductList>
        </div>
        <span v-else>
          <img  style="margin-bottom:50px"  src="@/assets/phone/004.jpg" />
          <ProductList :projects="deviceList" img-height="260px"></ProductList>
        </span>
      </div>

      <div class="column">
        <div class="wrpper" v-if="screenWidth > 768">
          <img style="margin-bottom:50px" src="@/assets/swiperProduct/sb01.png" />
          <!-- <Swiper :imgUrl="urlFour" :setHeight="setHg3" :during="during4">
          </Swiper> -->
          <ProductList :projects="sbDeviceList1" img-height="260px"></ProductList>
        </div>
        <span v-else>
          <img style="margin-bottom:50px" src="@/assets/phone/004.jpg" />
          <ProductList :projects="sbDeviceList1" img-height="260px"></ProductList>
        </span>
      </div>
      <div class="column">
        <div class="wrpper" v-if="screenWidth > 768">
          <ProductList :projects="sbDeviceList2" img-height="260px"></ProductList>
        </div>
        <span v-else>
          <img src="@/assets/phone/004.jpg" />
          <ProductList :projects="sbDeviceList2" img-height="260px"></ProductList>
        </span>
      </div>
      <div class="column">
        <div class="wrpper" v-if="screenWidth > 768">
          <ProductList :projects="sbDeviceList3" img-height="260px"></ProductList>
        </div>
        <span v-else>
          <img src="@/assets/phone/004.jpg" />
          <ProductList :projects="sbDeviceList3" img-height="260px"></ProductList>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "@/views/home/Swiper";
import HightLight from "@/components/common/hightLight/HightLight";
import Navbar from "@/views/product/navbar/Navbar";
import ProductList from "@/components/common/productList/ProductList";
import { eduProducts, lanProducts, indProducts, lanDevice, sbDevice1, sbDevice2, sbDevice3 } from "@/assets/products";

export default {
  name: "Product",
  components: { HightLight, Navbar, ProductList, Swiper },
  data() {
    return {

      lanProducts,
      indProducts,
      currentType: "",
      currentList: null,
      deviceList: null,
      sbDeviceList1: null,
      sbDeviceList2: null,
      sbDeviceList3: null,
      isBg: true,
      subTitle: "专业定制 / 快速打样 / 质量稳定",
      setHg1: "600px",
      setHg2: "600px",
      setHg3: "500px",
      during1: 4000,
      during2: 4000,
      during3: 4000,
      during4: 4000,
      screenWidth: localStorage.getItem("screenWidth") || window.innerWidth,
      urlOne: [
        {
          img: require("@/assets/swiperProduct/002.png"),
          title: "咖啡机电路板",
        },
        {
          img: require("@/assets/swiperProduct/003.png"),
          title: "吹风机电路板",
        },
        {
          img: require("@/assets/swiperProduct/004.png"),
          title: "水泵电路板",
        },
        {
          img: require("@/assets/swiperProduct/005.png"),
          title: "吸尘器电路板",
        },
      ],
      urlTwo: [
        {
          img: require("@/assets/swiperProduct/009.png"),
          extra: require("@/assets/swiperProduct/008.png"),
          title: "42HD2405N-24B",
          description: {
            product: "圆轴",
            size: "42mm*40mm",
            zhou: "20mm",
            pie: "5mm",
            support: "0.4N.m",
          },
        },
        {
          img: require("@/assets/swiperProduct/010.png"),
          extra: require("@/assets/swiperProduct/008.png"),
          title: "42HD9402N-24B",
          description: {
            product: "D轴",
            size: "42mm*60mm",
            zhou: "24mm",
            pie: "5mm",
            support: "0.65N.m",
          },
        },
        {
          img: require("@/assets/swiperProduct/011.png"),
          extra: require("@/assets/swiperProduct/008.png"),
          title: "57HD0407-21B1",
          description: {
            product: "D轴",
            size: "57mm*41mm",
            zhou: "21mm",
            pie: "8mm",
            support: "0.45N.m",
          },
        },
        {
          img: require("@/assets/swiperProduct/012.png"),
          extra: require("@/assets/swiperProduct/008.png"),
          title: "86HD8401-32J",
          description: {
            product: "D轴",
            size: "86mm*150mm",
            zhou: "32mm",
            pie: "14mm",
            support: "12N.m",
          },
        },
      ],
      urlThree: [
        {
          img: require("@/assets/swiperProduct/015.png"),
          title: "无人实验室操作平台",
        },
        {
          img: require("@/assets/swiperProduct/016.png"),
          title: "五轴机械手",
        },
        {
          img: require("@/assets/swiperProduct/017.png"),
          title: "scara机器人",
        },
      ],
      urlFour: [
        {
          img: require("@/assets/swiperProduct/018.png"),
          title: "拉力机",
        },
        {
          img: require("@/assets/swiperProduct/019.png"),
          title: "灭菌锅",
        },
        {
          img: require("@/assets/swiperProduct/020.png"),
          title: "流体测试仪",
        },
      ],
    };
  },
  mounted() {
    this.currentType = "教育照明";
    this.currentList = eduProducts;
    this.deviceList = lanDevice;
    this.sbDeviceList1 = sbDevice1;
    this.sbDeviceList2 = sbDevice2;
    this.sbDeviceList3 = sbDevice3;

    window.addEventListener("resize", this.updateScreenWidth); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth); // 移除监听器
  },
  methods: {
    itemClick(item) {
      switch (item) {
        case "智能设备":
          this.currentList = eduProducts;
          this.currentType = "智能设备";
          break;
        case "后台管理系统":
          this.currentList = lanProducts;
          this.currentType = "后台管理系统";
      }
    },
    projectClick(val) {
      console.log(val);
      this.$router.push({
        path: "/detail",
        query: {
          name: val.name,
          id: val.id,
          content: val.content,
        },
      });
    },
    updateScreenWidth() {
      this.screenWidth =
        localStorage.getItem("screenWidth") || window.innerWidth; // 更新屏幕宽度
    },
  },
};
</script>

<style scoped>
.product {
  display: flex;
  justify-content: center;
}

.list {
  width: 100%;
  /* 改为100%宽度以适应小屏幕 */
  text-align: center;
}

.list p {
  font-size: 30px;
}

.wrpper {
  width: 100%;
  margin: 0px auto;
}

.column {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
}

.column img {
  text-align: center;
  width: 100%;
}

.nav {
  margin-top: 135px;
}

.productList {
  margin-bottom: 50px;
}

#title {}

.column {
  img {
    width: 100%;
  }
}

.sub {
  display: inline-block;
  margin-top: 15px;
  font-size: 25px;
  color: #999;
}

/* 新增样式用于小屏幕下纵向排版 */
.productItem {
  margin-bottom: 20px;
}

.productImage {
  width: 100%;
  max-width: 300px;
  /* 调整图片宽度 */
  height: auto;
  /* 让图片高度自适应 */
}

@media screen and (max-width: 768px) {
  .product {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .nav {
    display: flex;
    justify-content: center;
    margin-top: 35px;
  }

  .list {
    width: 100%;
    /* 改为100%宽度以适应小屏幕 */
    /* text-align: center; */
  }

  .productList {
    padding-left: 0;
  }

  .list p {
    font-size: 30px;
  }

  #title {
    padding-right: 0;
  }
}
</style>
